// AUTO GENERATED FILE - Changes WILL be lost.
// zh-CN - used as 'zh' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "投注单",
  "product.last60-row-single": "NBA 最后 60 场单场比赛",
  "product.sb-english-single": "英格兰足球博彩单场比赛",
  "product.sb-italian-single": "意大利足球博彩单场比赛",
  "product.sb-greek-single": "希腊足球博彩单场比赛",
  "product.sb-english-league": "英格兰足球博彩联赛",
  "product.sb-italian-league": "意大利足球博彩联赛",
  "product.sb-greek-league": "希腊足球博彩联赛",
  "last60.fixture.pending": "{visitor} {'@'} {home}",
  "last60.fixture.result": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture.pending": "{home} VS. {away}",
  "sb.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "下注",
  "betslip.clear": "全部清除",
  "betslip.clearResult": "清除",
  "betslip.noSelections": "添加选项以开始投注",
  "betslip.notLoggedIn": "登录以开始投注",
  "betslip.refresh": "刷新",
  "betslip.totalStake": "总投注金",
  "betslip.noHistoryData": "无投注信息",
  "betslip.openBets": "投注未结算",
  "betslip.betHistory": "下注纪录",
  "betslip.betHistoryWon": "赢",
  "betslip.betHistoryLost": "输",
  "loading.loading": "加载中",
  "loading.account": "登录帐号中",
  "loading.league": "载入联赛",
  "loading.gameweeks": "载入比赛时间表",
  "loading.markets": "载入盘口",
  "loading.bethistory": "正在加载下註紀錄",
  "login.loginRequired": "需要登录",
  "login.loginToBet": "请登录以开始投注",
  "navigation.back": "返回",
  "navigation.close": "关闭",
  "video.liveStreamAvailable": "直播可用",
  "video.logInToWatch": "请登录观看",
  "error.error": "错误",
  "error.404": "网页未找到",
  "error.gameLaunchFailed": "无法启动",
  "error.unknownErrorCode": "未知错误: {code}",
  "error.minUnitStakeLimitExceeded": "最低投注额 {limit}",
  "error.maxUnitStakeLimitExceeded": "最高投注额 {limit}",
  "error.minTotalStakeLimitExceeded": "最低投注总额 {limit}",
  "error.maxTotalStakeLimitExceeded": "最高投注总额 {limit}",
  "error.stakeInvalidMultiple": "赌注必须是{multiple}的倍数",
  "error.notPlaced": "未投注",
  "error.wagerDisallowed": "禁止下注",
  "error.errorEventIsOff": "赛事已开始",
  "wagerType.Singles": "单式投注",
  "wagerType.Doubles": "二串一",
  "wagerType.Trebles": "三串一",
  "wagerType.Accumulator": "累计",
  "wagerType.Perm 4-Folds": "四串一",
  "wagerType.Perm 5-Folds": "五串一",
  "wagerType.Perm 6-Folds": "六串一",
  "wagerType.Perm 7-Folds": "七串一",
  "wagerType.Perm 8-Folds": "八串一",
  "wagerType.Perm 9-Folds": "九串一",
  "error.excess_bets": "投注单上最多可{limit}同时下注；请取消下注",
  "product.sb-turkish-league": "土耳其足球博彩联赛",
  "error.minBetslipLimitExceeded": "最低总投注额为{limit}。",
  "error.maxBetslipLimitExceeded": "最大总投注额为 {limit}",
  "error.exceededMaxPayout": "最大潜在赔率为 {limit}；请减少赌注。",
  "betslip.potentialReturns": "潜在回报",
  "betslip.taxDisclaimer": "投注结算时，您的所有净赢利均需缴税。税额将根据投注的潜在奖金计算。",
  "error.maintenanceEnabled": "服务器目前正在维护中",
  "error.internalError": "内部错误",
  "error.invalidSession": "会话无效",
  "error.accountDisabled": "帐户已禁用",
  "error.invalidPlayerID": "无效球员 ID",
  "error.insufficientBalance": "余额不足",
  "error.configError": "配置错误",
  "error.betPlaceFailed": "投注失败",
  "error.invalidProductID": "产品 ID 无效",
  "error.playerReachedGamingLimits": "玩家达到负责任的游戏限额",
  "error.gameCycleDoesNotExist": "游戏周期不存在",
  "error.betAmountLimitExceeded": "超出未验证玩家的潜在赢钱上限",
  "betslip.netStake": "净赌注",
  "betslip.tax": "税收",
  "error.badReturns": "潜在回报低于总股本",
  "betslip.taxDisclaimerPoland": "超过 2280 兹罗提的奖金将减少 10%。",
  "error.incompatibleVersion": "应用程序版本不支持。请升级。",
  "product.iihf-row-single": "国际冰联世界锦标赛",
  "iihf.fixture.pending": "{home} VS. {away}",
  "iihf.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "ui.returnToPlayer": "返回玩家",
  "abbr.ui.returnToPlayer": "RTP",
  "ui.averageReturnToPlayer": "该游戏的平均 RTP 为 {limit}",
  "error.betslipContainsInvalidOptions": "投注单包含红色的无效选项",
  "sb-english.team.ARS": "阿森纳",
  "sb-english.team.AST": "阿思顿维拉",
  "sb-english.team.BHA": "布来顿",
  "sb-english.team.BOU": "博尼茅斯",
  "sb-english.team.BUR": "伯恩利",
  "sb-english.team.CHE": "切尔西",
  "sb-english.team.CRY": "C. 宫",
  "sb-english.team.EVE": "埃弗顿",
  "sb-english.team.LEI": "莱切斯特",
  "sb-english.team.LIV": "利物浦",
  "sb-english.team.MNC": "曼彻斯特. C",
  "sb-english.team.MNU": "曼彻斯特联盟",
  "sb-english.team.NEW": "纽卡斯尔",
  "sb-english.team.SOU": "南安普敦",
  "sb-english.team.TOT": "托特纳姆",
  "sb-english.team.WAT": "沃特福德",
  "sb-english.team.WHU": "西汉姆",
  "sb-english.team.WOL": "伍尔弗",
  "sb-english.team.NOR": "诺维奇",
  "sb-english.team.SHU": "谢菲尔德. U",
  "sb-english.team.LEE": "利兹",
  "sb-english.team.FUL": "富勒姆",
  "sb-english.team.WBA": "西布罗姆",
  "sb-greek.team.AEK": "雅典AEK",
  "sb-greek.team.APS": "阿波罗·斯米尔尼斯",
  "sb-greek.team.ARI": "阿里斯塞萨洛尼基",
  "sb-greek.team.AST": "的黎波里紫苑酒店",
  "sb-greek.team.ATR": "阿特罗米托斯",
  "sb-greek.team.GIA": "帕斯·贾尼娜",
  "sb-greek.team.LEV": "利瓦迪亚科斯",
  "sb-greek.team.OFI": "奥菲",
  "sb-greek.team.OLM": "奥林匹亚科斯",
  "sb-greek.team.PTK": "帕纳辛纳科斯",
  "sb-greek.team.PNS": "帕尼奥奥斯",
  "sb-greek.team.PAO": "帕奥克·萨洛尼卡",
  "sb-greek.team.PLT": "普拉塔尼亚斯",
  "sb-greek.team.XAN": "克桑西",
  "sb-italian.team.MIL": "米兰",
  "sb-italian.team.ATA": "亚特兰大",
  "sb-italian.team.BOL": "博洛尼亚",
  "sb-italian.team.BRE": "布雷西亚",
  "sb-italian.team.CAG": "卡利亚里",
  "sb-italian.team.CHI": "切沃",
  "sb-italian.team.FIO": "佛罗伦萨",
  "sb-italian.team.GEN": "热那亚",
  "sb-italian.team.INT": "国际米兰",
  "sb-italian.team.JUV": "尤文图斯",
  "sb-italian.team.LAZ": "拉齐奥",
  "sb-italian.team.NAP": "那不勒斯",
  "sb-italian.team.ROM": "罗马",
  "sb-italian.team.SAM": "桑普多利亚",
  "sb-italian.team.UDI": "乌迪内斯",
  "sb-italian.team.VER": "维罗纳",
  "nomorebets": "投注结束",
  "playtime": "上场时间",
  "gameId": "赛事ID",
  "noGames": "无可用赛事，请稍后再回来查看",
  "Home": "主",
  "Away": "客",
  "Visitor": "客",
  "rules": "规则",
  "soccerbet.gameWeek": "赛事周",
  "soccerbet.noGameWeeks": "没有比赛时间表，请稍后再查看",
  "soccerbet.league": "联赛排名",
  "soccerbet.table.name": "名称",
  "soccerbet.table.won": "赢",
  "soccerbet.table.drawn": "和",
  "soccerbet.table.lost": "输",
  "soccerbet.table.points": "比分",
  "abbr.event.Both Teams To Score": "两队得分",
  "event.Both Teams To Score": "两队都进球",
  "event.Over / Under": "大/小",
  "event.Double Chance": "双重机会",
  "event.Match Result": "比赛结果",
  "event.Exact Goals": "正确比分",
  "event.Correct Score": "波胆",
  "event.Match Result Both Score": "比赛结果双方得分",
  "event.Result Und/Over 1.5 Total Goals": "赛事结果/小 1.5 总分",
  "event.Result Und/Over 2.5 Total Goals": "赛事结果大/小 2.5 总分",
  "event.Under Over 1.5 Total Goals": "大/小1.5 总分",
  "event.Under Over 2.5 Total Goals": "大/小2.5 总分",
  "event.Under Over 3.5 Total Goals": "大/小3.5 总分",
  "event.Under Over 4.5 Total Goals": "大/小4.5 总分",
  "event.Total Goals 1 To 2": "总进球数1至2",
  "event.Total Goals 1 To 3": "总进球数1至3",
  "event.Total Goals 1 To 4": "总进球数1至4",
  "event.Total Goals 2 To 3": "总进球数2至3",
  "event.Total Goals 2 To 4": "总进球数2至4",
  "event.Under Over 1.5 Home Goals": "大/小 1.5 主队得分",
  "event.Under Over 1.5 Away Goals": "大/小 1.5 客队得分",
  "event.Home Team Exact Goals": "主队正确比分",
  "event.Away Team Exact Goals": "客队正确比分",
  "selection.Yes": "是",
  "selection.No": "否",
  "selection.1+G": "1+进球",
  "selection.1+Ng": "1+没有进球",
  "selection.X+G": "X+进球",
  "selection.X+Ng": "X+没有进球",
  "selection.2+G": "2+进球",
  "selection.2+Ng": "2+没有进球",
  "selection.1+Yes": "1+是",
  "selection.1+No": "1+否",
  "selection.X+Yes": "X+是",
  "selection.X+No": "X+否",
  "selection.2+Yes": "2+是",
  "selection.2+No": "2+否",
  "selection.TID_ANY_GOAL_SCORED_YES": "进球",
  "selection.TID_ANY_GOAL_SCORED_NO": "没有进球",
  "selection.U": "小",
  "selection.O": "大",
  "selection.1+O": "1+大",
  "selection.X+O": "X+大",
  "selection.2+O": "2+大",
  "selection.1+U": "1+小",
  "selection.X+U": "X+小",
  "selection.2+U": "2+小",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "X",
  "selection.TID_HOME_WIN_OR_DRAW": "1x",
  "selection.TID_DRAW_OR_AWAY_WIN": "x2",
  "selection.TID_HOME_OR_AWAY_WIN": "12",
  "selection.Over": "超过",
  "selection.Under": "在下面",
  "abbr.sb-english.team.ARS": "辅助生殖系统",
  "abbr.sb-english.team.AST": "谷草转氨酶",
  "abbr.sb-english.team.BHA": "水杨酸",
  "abbr.sb-english.team.BOU": "布欧",
  "abbr.sb-english.team.BUR": "布尔",
  "abbr.sb-english.team.CHE": "车",
  "abbr.sb-english.team.CRY": "哭",
  "abbr.sb-english.team.EVE": "前夕",
  "abbr.sb-english.team.LEI": "雷伊",
  "abbr.sb-english.team.LIV": "生命值",
  "abbr.sb-english.team.MNC": "跨国公司",
  "abbr.sb-english.team.MNU": "明尼苏达大学",
  "abbr.sb-english.team.NEW": "新的",
  "abbr.sb-english.team.SOU": "苏",
  "abbr.sb-english.team.TOT": "TOT",
  "abbr.sb-english.team.WAT": "瓦特",
  "abbr.sb-english.team.WHU": "武汉大学",
  "abbr.sb-english.team.WOL": "网络电话",
  "abbr.sb-english.team.NOR": "也不",
  "abbr.sb-english.team.SHU": "舒",
  "abbr.sb-english.team.LEE": "LEE",
  "abbr.sb-english.team.FUL": "完整的",
  "abbr.sb-english.team.WBA": "世界拳击协会",
  "abbr.sb-italian.team.MIL": "军用级",
  "abbr.sb-italian.team.ATA": "ATA",
  "abbr.sb-italian.team.BOL": "玻尔",
  "abbr.sb-italian.team.BRE": "布雷",
  "abbr.sb-italian.team.CAG": "冠状动脉造影",
  "abbr.sb-italian.team.CHI": "气",
  "abbr.sb-italian.team.FIO": "菲奥",
  "abbr.sb-italian.team.GEN": "根",
  "abbr.sb-italian.team.INT": "INT",
  "abbr.sb-italian.team.JUV": "联合UV",
  "abbr.sb-italian.team.LAZ": "拉兹",
  "abbr.sb-italian.team.NAP": "小憩",
  "abbr.sb-italian.team.ROM": "只读存储器",
  "abbr.sb-italian.team.SAM": "萨姆",
  "abbr.sb-italian.team.UDI": "UDI",
  "abbr.sb-italian.team.VER": "版本",
  "abbr.sb-greek.team.AEK": "AEK",
  "abbr.sb-greek.team.APS": "APS",
  "abbr.sb-greek.team.ARI": "阿里",
  "abbr.sb-greek.team.AST": "谷草转氨酶",
  "abbr.sb-greek.team.ATR": "衰减全反射",
  "abbr.sb-greek.team.GIA": "美国宝石研究院",
  "abbr.sb-greek.team.LEV": "LEV",
  "abbr.sb-greek.team.OFI": "奥菲",
  "abbr.sb-greek.team.OLM": "哦我是",
  "abbr.sb-greek.team.PTK": "PTK",
  "abbr.sb-greek.team.PNS": "三七总皂甙",
  "abbr.sb-greek.team.PAO": "聚氧化酶",
  "abbr.sb-greek.team.PLT": "PLT",
  "abbr.sb-greek.team.XAN": "XAN",
  "sb-turkish.team.AKB": "阿克希萨体育",
  "sb-turkish.team.BES": "贝西克塔斯",
  "sb-turkish.team.FEN": "费内巴切",
  "sb-turkish.team.GAL": "加拉塔萨雷",
  "sb-turkish.team.TRA": "特拉布宗体育",
  "sb-turkish.team.ANT": "安塔利亚体育",
  "sb-turkish.team.GEN": "将军",
  "sb-turkish.team.KAS": "卡辛帕萨",
  "sb-turkish.team.BUR": "布尔萨波尔",
  "sb-turkish.team.KAY": "凯瑟里斯体育",
  "sb-turkish.team.SIV": "西瓦斯波尔",
  "sb-turkish.team.IBA": "伊斯坦布尔 巴阿克希希尔",
  "sb-turkish.team.HAT": "哈泰体育",
  "sb-turkish.team.ADS": "广告。德米尔斯波尔",
  "sb-turkish.team.ALT": "阿勒泰",
  "sb-turkish.team.GAZ": "加济安泰普",
  "sb-turkish.team.GOZ": "戈兹泰佩",
  "sb-turkish.team.KON": "科尼亚体育",
  "sb-turkish.team.CRS": "C。里兹体育",
  "sb-turkish.team.ALS": "阿拉尼亚体育",
  "abbr.sb-turkish.team.AKB": "AKB",
  "abbr.sb-turkish.team.BES": "贝斯",
  "abbr.sb-turkish.team.FEN": "分",
  "abbr.sb-turkish.team.GAL": "伽蓝",
  "abbr.sb-turkish.team.TRA": "特拉",
  "abbr.sb-turkish.team.ANT": "蚂蚁",
  "abbr.sb-turkish.team.GEN": "根",
  "abbr.sb-turkish.team.KAS": "卡斯",
  "abbr.sb-turkish.team.BUR": "布尔",
  "abbr.sb-turkish.team.KAY": "凯",
  "abbr.sb-turkish.team.SIV": "SIV",
  "abbr.sb-turkish.team.IBA": "国际律师协会",
  "abbr.sb-turkish.team.HAT": "帽子",
  "abbr.sb-turkish.team.ADS": "ADS",
  "abbr.sb-turkish.team.ALT": "丙氨酸转氨酶",
  "abbr.sb-turkish.team.GAZ": "嘎斯",
  "abbr.sb-turkish.team.GOZ": "戈兹",
  "abbr.sb-turkish.team.KON": "康恩",
  "abbr.sb-turkish.team.CRS": "慢性RS",
  "abbr.sb-turkish.team.ALS": "肌萎缩侧索硬化症",
  "sb-english.team.BRE": "布伦特福德",
  "abbr.sb-english.team.BRE": "布雷",
  "sb-english.team.NOT": "诺丁汉F.",
  "abbr.sb-english.team.NOT": "不是"
}
